import React, { useRef, useEffect } from 'react';
import { Box, Typography, Button, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = ({message}) => {
  const navigate = useNavigate();
  const imageRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 30;
      const y = (e.clientY / window.innerHeight - 0.5) * 30;

      if (imageRef.current) {
        imageRef.current.style.transform = `translate(${x}px, ${y}px)`;
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={6} alignItems="center">
          <Box
            ref={imageRef}
            component="img"
            src="/notfound.svg"
            alt="404 Illustration"
            sx={{
              maxWidth: 400,
              transition: 'transform 0.3s ease-out',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          />

          <Stack spacing={3} textAlign={{ xs: 'center', md: 'left' }} sx={{ display: 'flex',alignItems: 'center' }}>
            <Typography variant="h2" fontWeight="bold" color="primary">
              404 - Page Not Found
            </Typography>
            <Typography variant="body1" color="text.primary">
                {message ? message : (
                  <>
                    Sorry, the page you’re looking for doesn’t exist or has been moved.Let’s get you back to the homepage.
                  </>
                )}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ width: { xs: '100%', md: 'fit-content' }, borderRadius: 2 }}
              onClick={() => navigate('/')}
            >
              Back to Home
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default PageNotFound;
